<template>

  <div class="bucket-form box">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Slug</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="form.slug"
              placeholder="e.g. prep"
            />
          </div>
          <p v-if="errors.slug" class="help is-danger">{{ errors.slug }}</p>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Label</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="form.label"
              placeholder="e.g. Preparation"
            />
          </div>
          <p v-if="errors.label" class="help is-danger">{{ errors.label }}</p>
        </div>
      </div>

      <div class="column is-narrow">
        <div class="field">
          <label class="label">Sort Order</label>
          <div class="control">
            <input
              class="input"
              type="number"
              v-model.number="form.sort_order"
              placeholder="0"
              style="width: 80px;"
            />
          </div>
          <p v-if="errors.sort_order" class="help is-danger">{{ errors.sort_order }}</p>
        </div>
      </div>
    </div>

    <div class="field is-grouped">
      <div class="control">
        <button
          class="button is-success is-small"
          @click="handleSave"
          :disabled="saving"
        >
          Save
        </button>
      </div>
      <div class="control">
        <button
          class="button is-small"
          @click="$emit('cancel')"
          type="button"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

</template>
<script>

  export default {

    props: {
      bucket: {
        type: Object,
        required: false,
        default: null,
      },
      errors: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      saving: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data () {
      let bucket = this.bucket;
      return {
        form: {
          slug: bucket ? bucket.slug : '',
          label: bucket ? bucket.label : '',
          sort_order: bucket ? bucket.sort_order : 0,
        },
      };
    },

    methods: {

      handleSave () {
        let {slug, label, sort_order} = this.form;
        this.$emit('save', {slug, label, sort_order});
      },

    },
  };

</script>

<style lang="scss" scoped>
  .bucket-form {
    margin-bottom: 1rem;
  }
</style>
